import { Component, HostListener, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InsuranceService } from 'app/modules/insurance/services/insurance.service';
import { OrderService } from 'app/modules/order/services/order.service';
import { UpdateProfileService } from 'app/modules/update-profile/services/update-profile.service';
import { Constants } from 'app/shared/constant/constants';
import { ConstantsKey } from 'app/shared/constant/constants-keys';
import { GTMDataLayerService } from 'app/shared/services/gtmDataLayer.service';
import { CryptoUtils } from 'app/shared/utility/crypto.utils';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: [
    './payment-success.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PaymentSuccessComponent implements OnInit {

  public orderId: string;
  public orderDetails: any;
  public showLoader: boolean = true;
  public paymentStatus: any;
  public paymentMode: any;
  public forexMarginString: String = '0.00';
  public cryptoUtils: CryptoUtils = new CryptoUtils();
  public insuranceDetails: any;
  public insuranceId: any;
  public showSuccessContent: any;
  public modalReference: any;

  public consumerDetail: any;
  public isProfileComplete: any;
  public isVcipComplete: any;
  navigateRouteCard: string;
  navigateRouteRemittance: string;
  navigateRoutePersonalRemittance: string;
  public showVCIPPopup: boolean = false;
  public scheduleVCIPLater : boolean = false ;
  @ViewChild('VCIPModal') VCIPModal: TemplateRef<any>;
  vkycTimingText: any;
  public orderType: string =  "FOREX-ORDER";
  steps: any;
  isFromRetryPaymentPage:boolean = false;
  public xplorerOrderDetail: any;

  stepsforStudent = [
    { title: 'University', subtitle: 'University Details', icon: 'assets/images/cartStepper/University.png'  },
    { title: 'Student', subtitle: 'Student Details', icon: 'assets/images/cartStepper/Student.png' },
    { title: 'Payment', subtitle: 'Complete your payment', icon: 'assets/images/cartStepper/payment.png' },
    { title: 'KYC', subtitle: 'Complete your KYC', icon: 'assets/images/cartStepper/KYC.png' }
  ];

  stepsforCard = [
    { title: 'Trip Info', subtitle: 'Trip Details', icon: 'assets/images/cartStepper/TripInfo.png' },
    { title: 'Traveller', subtitle: "Delivery date and address", icon: 'assets/images/cartStepper/Traveller.png' },
    { title: 'Payment', subtitle: 'Complete your payment', icon: 'assets/images/cartStepper/payment.png' },
    { title: 'KYC', subtitle: 'Accept A2 Form', icon: 'assets/images/cartStepper/KYC.png' }
  ];


    stepsforUniCard = [
    { title: 'Information', subtitle: 'Details', icon: 'assets/images/cartStepper/TripInfo.png' },
    { title: 'Customer Details', subtitle: "Select Source of Funds", icon: 'assets/images/cartStepper/Traveller.png' },
    { title: 'Payment', subtitle: 'Complete your payment', icon: 'assets/images/cartStepper/payment.png' },
    { title: 'KYC', subtitle: 'Accept A2 Form', icon: 'assets/images/cartStepper/KYC.png' }
  ];
   
   
  stepsforOthers = [
    { title: 'Beneficiary', subtitle: 'Beneficiary Details', icon: 'assets/images/cartStepper/Traveller.png'},
    { title: 'Payment', subtitle: 'Complete your payment', icon: 'assets/images/cartStepper/payment.png' },
    { title: 'KYC', subtitle: 'Complete your KYC', icon: 'assets/images/cartStepper/KYC.png' }
  ];
  
  currentStep = 2; // Set dynamically
  isMobile = window.innerWidth <= 768;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobile = event.target.innerWidth <= 768;
  }

  private historyState: any = { trapped: true }; // To keep the history entry
  private popstateEventListener: any;
	@ViewChild('backButtonRestricationModal') backButtonRestricationModal: TemplateRef<any>;
	@ViewChild('xplorerDeliverMsgModal') xplorerDeliverMsgModal: TemplateRef<any>;   
  public custMobile = ""; 
  public isOnlyCashOrder:boolean = false;  

  constructor(  
    private route: ActivatedRoute,
    public orderService: OrderService,
    private router: Router,
    public modalService: NgbModal,
    public updateProfileService: UpdateProfileService,
    public insuranceService: InsuranceService,
    public gtmPushService: GTMDataLayerService,
    public toast: ToastrService) { }

  ngOnInit(): void {
    this.vkycTimingText= Constants.vkycTimingText;
    this.route.params.subscribe((params: Params) => {
      this.orderId = params['orderId'];
        console.log("this.orderId ----------------------",this.orderId);
        window.history.pushState(this.historyState, '', window.location.href);
        // Step 2: Intercept back navigation using the popstate event
        this.popstateEventListener = this.onPopState;
        // Add listener for popstate event
        window.addEventListener('popstate', this.popstateEventListener);    

    });

    let consumerData = localStorage.getItem(ConstantsKey.CONSUMER_DATA);
    if(consumerData) {
      consumerData = JSON.parse(consumerData);
      this.custMobile = consumerData["mobile"];
    }

    let orderData = localStorage.getItem(ConstantsKey.CURRENT_ORDER_TYPE);

    let retryPaymet = sessionStorage.getItem(ConstantsKey.IS_FROM_RETRY_PAYMENT);

    if(retryPaymet && retryPaymet == 'true') {
       this.isFromRetryPaymentPage = true;
    } else {
      this.isFromRetryPaymentPage = false;
      if(sessionStorage.getItem('Navigate_Back_to_stepper')) {
        this.navigateRouteRemittance = sessionStorage.getItem('Navigate_Back_to_stepper');
        this.steps = this.stepsforStudent;
      } else if(sessionStorage.getItem('Navigate_Back_to_stepper3')) {
        this.navigateRoutePersonalRemittance = sessionStorage.getItem('Navigate_Back_to_stepper3');
        this.steps = this.stepsforOthers;
        this.currentStep = 1;
      } else if(sessionStorage.getItem('Navigate_Back_to_stepper_card')) {
        this.navigateRouteCard = sessionStorage.getItem('Navigate_Back_to_stepper_card');
        // this.steps = this.stepsforCard;
      }      
    }

    if(orderData) {
      let parseOrderData = JSON.parse(orderData);
      let localOrderId = parseOrderData["ORDER_ID"];
      console.log("ORDER ID ------------------ ",this.orderId , localOrderId);
      if(this.orderId == localOrderId) {
        this.orderType = parseOrderData["ORDER_TYPE"];
        console.log("this.orderType ---------------- ", this.orderType);
        if(this.orderType == "ESIM") {
          localStorage.removeItem(ConstantsKey.IS_ESIM_ORDER_DONE);
        } else if(this.orderType == "LOUNGE") {
          localStorage.removeItem(ConstantsKey.IS_LOUNGE_ORDER_DONE);
        } else if(this.orderType == "XPLORER_CARD") {
          localStorage.removeItem(ConstantsKey.IS_XPLORER_ORDER_DONE);
        } else if(this.orderType == "INSURANCE") {
          localStorage.removeItem(ConstantsKey.IS_INSURANCE_ORDER_DONE);
        } else {
          if(localStorage.getItem(ConstantsKey.IS_STUD_REMITTANCE_ORDER_DONE)) {
            localStorage.removeItem(ConstantsKey.IS_STUD_REMITTANCE_ORDER_DONE)
          } 
          if(localStorage.getItem(ConstantsKey.IS_PERS_REMITTANCE_ORDER_DONE)) {
            localStorage.removeItem(ConstantsKey.IS_PERS_REMITTANCE_ORDER_DONE)
          }
          if(localStorage.getItem(ConstantsKey.IS_CARD_ORDER_DONE)) {
            localStorage.removeItem(ConstantsKey.IS_CARD_ORDER_DONE)
          }
  
        }

        if(this.orderType == "XPLORER_CARD") {
          this.getXplorerOrderDetail(this.orderId);
        } else {
          this.getSingleOrderDetails();           
        }

        this.showLoader = false;
      }
    } else {
      this.getSingleOrderDetails();
    }




   // this.getProfileDetails();

  }

  getSingleOrderDetails() {
    this.showLoader = true;
    this.orderService.getOrderDetailsSingle(this.orderId).subscribe(respOrderData => {
      if (respOrderData['status'] == 200) {
        this.showLoader = false;
        this.orderDetails = respOrderData.body;
        this.paymentStatus = this.orderDetails?.orderStatusGroup?.consumerPayment;
        this.paymentMode = this.orderDetails?.paymentMode;
        let paymentMode = sessionStorage.getItem(ConstantsKey.PAYMENT_METHOD);
        if (paymentMode == 'NB' && this.paymentStatus == 'PENDING') {
          this.router.navigate(['/payment-failed', this.orderId]);
        } else if ((paymentMode == 'MANUAL' && (this.paymentStatus == 'COMPLETED' || this.paymentStatus == 'PENDING')) || ((paymentMode == 'NB' || paymentMode == 'UPI') && (this.paymentStatus == 'COMPLETED' || this.paymentStatus == 'PARTIAL'))) {
          this.showSuccessContent = true;
        }
        if (this.orderDetails?.invoice?.marginCharges != null) {
          this.forexMarginString = this.orderDetails?.invoice?.marginCharges.toFixed(2) + "";
        }

        const exists = this.orderDetails?.orderItems.some(productList => productList.product === "FOREXCARD" || productList.product === "REMITTANCE");
        if(exists) {
          this.isOnlyCashOrder = false;
        } else {
          this.isOnlyCashOrder = true;        
        }        
        
        if(this.navigateRouteCard!=null && this.navigateRouteCard == "true") {
          let orderItem = this.orderDetails["orderItems"];
          let forexOrder = orderItem.filter((order:any) => order.issuerCode == 'WSFXUNIMCC');
          if(forexOrder.length == 1) {
            if(this.isMobile) {
              this.stepsforUniCard[1].title = "Details";
            }
            this.steps  = this.stepsforUniCard;
          } else {
            this.steps = this.stepsforCard;
          }
        }

        let payMode = "";
        if(this.paymentMode == "MANUAL") {
          payMode = "NEFT";
        } else if(this.paymentMode == "NB") {
          payMode = "Netbanking";
        } else if(this.paymentMode == "UPI") {
          payMode = "UPI";
        }

        let gtmObj = {
          "event": "payments",
          "book_and_pay": this.paymentStatus == "PARTIAL" ? "Y" : "N",
          "mode_of_payment": payMode,
          "mobile": this.custMobile != "" ? "91"+this.custMobile : ""
        };

        this.gtmPushService.dataLayerPushData(gtmObj);


      }
    }, error => {
      this.showLoader = false;
      this.insuranceService.getTravelInsuranceCartDetails(this.orderId).subscribe(respInsuranceData => {
        this.showLoader = false;
        this.insuranceDetails = respInsuranceData.body;
        this.insuranceId = this.insuranceDetails.cart[0].insuranceOrderId;
      }, error => {
        this.insuranceDetails = JSON.parse(this.cryptoUtils.resDecrypt(error.error.text));
        this.insuranceId = this.insuranceDetails.cart[0].insuranceOrderId;
        console.log('INSURANCE DETAILS >>> ', JSON.stringify(this.insuranceDetails));
      });
    });
  }

  getProfileDetails() {
    this.updateProfileService.getProfileListAll().subscribe(resp => {
      this.showLoader = false;
      this.consumerDetail = resp.body;

      this.isProfileComplete = this.consumerDetail.paxResponse?.profileComplete;
      this.isVcipComplete = this.consumerDetail?.vcipKyc;
      let vcipCompletionFlag = localStorage.getItem(ConstantsKey.IS_VCIP_COMPLETE);
      console.log(vcipCompletionFlag);
      console.log(this.isVcipComplete);
      if (!this.isVcipComplete && vcipCompletionFlag == 'false') {
        this.showVCIPPopup = true;
        setTimeout(() => {
          this.modalReference = this.modalService.open(this.VCIPModal, { size: 'xl', centered: true });
          }, 3000);
      } 
    });
  }


  initiateVcip() {
    this.modalReference.close();
    this.updateProfileService.getVCIPRedirectionURL().subscribe((resp => {
      this.showLoader = false;
      var vcipResponse = JSON.parse(JSON.stringify(resp.body));
      let vcipUrl = vcipResponse.mobileAutologinUrl;
      window.open(vcipUrl, '_blank');
    }), error => {
      this.showLoader = false;
      this.toast.error(JSON.stringify(error.error.message));
    });
  }

  closePopup(){
    this.scheduleVCIPLater = true;
  }

  navigateToRating(VCIPModal) {

    if(this.isFromRetryPaymentPage) {
      this.router.navigate(['/order-details', this.orderId]);
    } else {
      if(this.navigateRouteRemittance!=null && this.navigateRouteRemittance == "true") {
        sessionStorage.removeItem('Navigate_Back_to_stepper');
        this.router.navigate(['/stepper'], { queryParams: { orderId: this.orderId } });
      } else if (this.navigateRoutePersonalRemittance == "true") {
        sessionStorage.removeItem('Navigate_Back_to_stepper3');
        this.router.navigate(['/stepper3step'], { queryParams: { orderId: this.orderId } });
      } else if (this.navigateRouteCard!=null && this.navigateRouteCard == "true") {
        sessionStorage.removeItem('Navigate_Back_to_stepper_card');
        this.router.navigate(['/card-stepper'], { queryParams: { orderId: this.orderId } });
      } else {
        this.router.navigate(['/ratings', this.orderId]);
      }
    }


    // if (this.showVCIPPopup && !this.scheduleVCIPLater) {
    //   this.modalReference = this.modalService.open(VCIPModal, { size: 'xl', centered: true });
    // } else {
    //   this.router.navigate(['/ratings', this.orderId]);
    // }
  }

  retryPayment() {
    this.router.navigate(['/retry-payment', this.orderId]);
  }

  goToOrderDetails() {
    this.router.navigate(['/order-details', this.orderId]);
  }

  goToInsuranceDetails() {
    // this.router.navigate(['/insurance-list']);
    this.router.navigate(['/insurance-details', this.insuranceId]);
  }

  goToAddOnOrderDetails() {
    console.log("this.orderType ------------------ ", this.orderType);
    if(this.orderType == "LOUNGE") {
      this.router.navigate(['/add-on/order-details',this.orderType.toLocaleLowerCase(), this.orderId]);
    } else if(this.orderType == "ESIM") {
      this.router.navigate(['/add-on/order-details',this.orderType.toLocaleLowerCase(), this.orderId]);
    } else if(this.orderType == "XPLORER_CARD") {
      this.router.navigate(['/add-on/order-list/xplorer']);
    }
  }

  onPopState = (event: PopStateEvent) => {
    // Push the state back to trap the user again
    console.log("TEST");
    window.history.pushState(this.historyState, '', window.location.href);
    this.modalReference = this.modalService.open(this.backButtonRestricationModal, { size: 'sm', centered: true });
  };

  ngOnDestroy(): void {
    window.removeEventListener('popstate', this.popstateEventListener);
  }

  closeBackButtonModal() {
    this.modalReference.close();
  }  

  getXplorerOrderDetail(xplorerOrderId: String) {
    console.log("resp xplorerOrderId --------------------- ", xplorerOrderId);
    this.orderService.getXplorerOrderDetail(xplorerOrderId).subscribe(resp => {
      console.log("resp --------------------- ", resp);
      let xplorerCard = resp.body;
      this.xplorerOrderDetail = xplorerCard["order"];
      // this.xplorerOrderDetail = resp.body;
        this.modalReference = this.modalService.open(this.xplorerDeliverMsgModal, { size: 'sm', centered: true });        
    }, err => {

    });
  }



}